export default "__VITE_ASSET__D41q7FwN__"